import { http } from '../../../api'

const admin = {
  namespaced: true,
  state: {
    admins: null
  },
  actions: {

    getAdminLists: ({ commit }, params) => {
      let url = '/admin'
      if (params) {
        const q = new URLSearchParams(params)
        url = url + '?' + q.toString()
      }
      return http.get(url).then(res => {
        commit('setAdminList', res.data.data)
        return res.data
      })
    },
    getAdminInfo: ({ commit }, id) => {
      return http.get('/admin/' + id).then(res => {
        return res.data.data
      })
    },
    gatAllRoles: ({ commit }) => {
      return http.get('/admin/create').then(res => {
        return res.data.data
      })
    },
    createAdminInfo: ({ commit }, params) => {
      return http.post('/admin', params.data).then(res => {
        return res.data.data
      })
    },
    updateAdminInfo: ({ commit }, params) => {
      return http.put('/admin/' + params.id, params.data).then(res => {
      })
    },
    deleteItem: ({ commit }, id) => {
      return http.delete('/admin/' + id).then(res => {
        commit('deleteAdmin', id)
      })
    }
  },
  mutations: {
    setAdminList (state, data) {
      state.admins = data
    },
    deleteAdmin (state, id) {
      state.admins = state.admins.filter(item => item.id !== id)
    }
  },
  getters: {
    admins: state => state.admins
  }
}

export default admin
